import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import { CANTILEVER_DOCUMENT_PAGE_TAG } from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'
import type { DocumentPageMetadataUserEditPutData } from 'features/knowledgeDocumentViewer/utils/buildDocumentPageMetadataUserEditPut'
import { documentPageMetadataUserEditsByCantileverPageTag } from 'features/knowledgeDocumentViewer/utils/documentEntryLookups'
import type { RolodexEntryPutJson } from 'types'
import { RolodexEntryType } from 'types'

export type SeedDocumentPageMetadataUserEditMutate = (
  key: [string, string],
  data: DocumentPageMetadataUserEditEntry[],
  opts: { revalidate: boolean }
) => Promise<unknown>

function putToLoadEntry(
  put: RolodexEntryPutJson<DocumentPageMetadataUserEditPutData>
): DocumentPageMetadataUserEditEntry {
  return {
    entry: {
      id: put.id,
      type: RolodexEntryType.DOCUMENT_PAGE_METADATA_USER_EDIT,
      data: put.data,
      tags: put.tags,
    },
  }
}

/** Seed per-page user-edit SWR keys (inactive siblings miss filter revalidate). */
export async function seedDocumentPageMetadataUserEditCaches({
  endpoint,
  siteId,
  puts,
  mutate,
}: {
  endpoint: string
  siteId: string
  puts: readonly RolodexEntryPutJson<DocumentPageMetadataUserEditPutData>[]
  mutate: SeedDocumentPageMetadataUserEditMutate
}): Promise<void> {
  await Promise.all(
    puts.map((put) => {
      const cantileverPageHostId = put.tags[CANTILEVER_DOCUMENT_PAGE_TAG]
      if (!cantileverPageHostId) return Promise.resolve()
      const loadOptions = documentPageMetadataUserEditsByCantileverPageTag(
        cantileverPageHostId,
        { site: siteId }
      )
      const key: [string, string] = [endpoint, JSON.stringify(loadOptions)]
      return mutate(key, [putToLoadEntry(put)], { revalidate: false })
    })
  )
}
